import request from '@/utils/request';
import BaseService from './base';

export interface CourseViewModel {
  id?: number;
  name?: string;
  introduce?: string;
  author?: string;
  icon?: string;
  displayPos?: number;
}

export class CourseService extends BaseService<CourseViewModel> {
  protected serviceApi: string = 'Course';

  get NewModel(): CourseViewModel {
    return {
      id: 0,
      name: '',
      introduce: '',
      author: '',
      icon: '',
      displayPos: 0,
    };
  }

  // public GetMaxPos() {
  //   return request({
  //     url: `${this.serviceApi}/GetMaxPos`,
  //     method: 'post',
  //   });
  // }
  public GetByRights() {
    return super.GetUrl('/GetByRights');
  }
}

